module.exports = __webpack_public_path__ + "img/nature-15.7eba9763.jpg";